
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'LetterIcon'
})
export default class LetterIcon extends Vue {
  @Prop()
  private letter: string;

  @Prop({ default: '#FFF' })
  private color: string;

  @Prop({ default: 20 })
  private x: number

  @Prop({ default: 20 })
  private y: number
}
